import React from 'react';
import { getConfig, getTranslation } from '../utils/config';
import { usePinned } from '../hooks/use-pinned';
import { UPDATE_TOAST } from '../context/actions';
import { useDfContext } from '../context/df-context';

export default function Pin({
  id,
  group,
}: {
  id: number | string;
  group: number | string;
}): React.ReactElement {
  const { dispatch } = useDfContext();
  const { isPinned, togglePin } = usePinned();
  const pinned = isPinned(id);

  const pinItem = () => {
    togglePin(id, group);
    dispatch({
      type: UPDATE_TOAST,
      showToast: true,
      message: getTranslation(pinned ? 'bookmark_removed' : 'bookmark_added'),
    });
  };

  return (
    <button
      className={
        pinned
          ? 'df-icon-btn df-bookmark-pin df-bookmark-pin--active'
          : 'df-icon-btn df-bookmark-pin'
      }
      onClick={pinItem}
      aria-label={getTranslation('bookmark')}
      title={getTranslation(pinned ? 'bookmark_removed_title' : 'bookmark_added_title')}
    >
      <svg className="df-action-icon keep-fill">
        <use href={getConfig('material_symbols_url') + '#keep_400-fill'} />
      </svg>

      <svg className="df-action-icon keep">
        <use href={getConfig('material_symbols_url') + '#keep_400'} />
      </svg>
    </button>
  );
}
